import GetBack from "./getBack";
import EarnCashBackSteps from "./earnCashBackSteps";
import PaymentStatus from "./paymentStatus";
import ShareOptions from "./shareOptions";
import { Popover, Button } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import RedeemCash from "./redeemCash/RedeemCash";
import Information from "./information";
import ReactGA from "react-ga4";
import { useNavigate } from "react-router-dom";

interface DataProps {
  data?: any;
}

const content = (
  <div className="custom-popover">
    <p>
      Help your friends and family make their skincare simple too! When they
      sign up for the caring personalized skincare consultation, you will get
      cash back.
    </p>
  </div>
);

const EarnCashBackComponent: React.FC<DataProps> = ({ data }: any) => {
    const navigate = useNavigate();
  return (
    <div className="earn__cash__back">
      <div className="earn__cash__back__content">
        <div className="header">
          {/* <h1>Share and Earn 100% Cash Back</h1> */}
          <h1 className="store-card__title">Share & Earn 5% Recurring Cash</h1>
          {/* <Popover
            content={content}
            trigger="click"
            style={{
              background: "red",
              width: "350px",
            }}
          >
            <InfoCircleFilled />
          </Popover> */}
        </div>
        <EarnCashBackSteps data={data} />
      </div>
      {/* <GetBack data={data} /> */}
      <RedeemCash data={data} />
      <PaymentStatus data={data} />
      <ShareOptions data={data} />
      <Information />
        <div className="footer-cta">
            <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/liked-your-space");
            ReactGA.event({
              category: "Store",
              action: `Go to Holistic Care button clicked`,
              label: "",
              nonInteraction: true, // optional, true/false
              transport: "xhr",
            });
          }}
        >
          Go to Your Space
        </Button>
        </div>
    </div>
  );
};

export default EarnCashBackComponent;
